<template>

    <label class="toggle">  

        <input  
          :checked="checked"  
          @change="changeInput"      
           
          value="1"  type="checkbox"  
        />  

        <span class="slider round" />

    </label>

</template>

<script>

    export default {
        props: {
        value: { type: Boolean, default: false }
        },
        data() {
            return {
              checked: this.value
            }
        },
        watch: {
            checked(val) {
                //this.$emit('input', this.checked);
            }
        },
        methods: {
            changeInput() {
              this.checked = !this.checked;
              this.$emit('toggle-event', this.checked);
            },
            SetValue(value) {
              this.checked = (value == false) ? false : true;
            }
    }
  }
  </script>

  <style scoped>

    .toggle {
      position: relative;
      display: inline-block;
      width: 26px;
      height: 16px;
      margin-top: 10px;
    }

    .toggle input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #fff;
      -webkit-transition: .2s;
      transition: .2s;
      border:1px solid #ffffff;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: -3px;
      bottom: -2px;
      background-color: #2567A2;
      -webkit-transition: .2s;
      transition: .2s;
      border: solid 1.5px #fff;
    }

    input:checked + .slider {
      background-color: transparent;
    }

    input:focus + .slider {
      box-shadow: 0 0 1px #2567A2;
    }

    input:checked + .slider:before {
      -webkit-transform: translateX(31px);
      -ms-transform: translateX(31px);
      transform: translateX(15px);
      background: #2567A2;
      -webkit-transition: .2s;
      transition: .2s;
      border: solid 2px #fff;
    }

    .slider.round {
      border-radius: 20px;
      border-color: #ffffff;
    }

    .slider.round:before { 
      border-radius: 50%;
      border-color: #ffffff;
    }

</style>
